import {
  BButton,
  BModal,
  VBModal,
  VBToggle,
  BFormGroup,
  BFormInput,
} from "bootstrap-vue";
export default {
  components: {
    BButton,
    BModal,
    BFormGroup,
    BFormInput,
  },
  directives: {
    "b-toggle": VBToggle,
    "b-modal": VBModal,
  },
  data() {
    return {
      url: "admin/customers_club/add_bon_value",
      selectedValue: "",
      disabled: false,
    };
  },
  methods: {
    async submit() {
      this.disabled = true;
      await this.$axios
        .post(
          `${this.url}?value=${this.selectedValue ? this.selectedValue : ""}`
        )
        .then((res) => {
          this.$root.notify(res.data.message, "success");
          this.$emit("after-update", res.data.data.list);
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
  },
};
